import React from "react";
import { TouchableOpacity, Text, StyleSheet, View, Image } from "react-native";
import { AppFontStyle } from "../styles/AppFontStyle";
import { AppColors } from "../utility/AppColors";
import { FlatList } from "react-native-gesture-handler";
import { AppScreens } from "../screens/Utility/AppScreens";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../utility/NavigationHelper";
import { userData } from "../utility/types/userTypes";
import ImageComponent from "./ImageComponent";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Avatar from "./choose-avatar-components/Avatar";

interface PlayersView {
  profilePicture?: string;
  userID?: string;
}

type PlayersViewScrollProps = {
  userData?: userData;
  arrPopularGeners?: PlayersView[];
};

const PlayersViewScroll: React.FC<PlayersViewScrollProps> = ({
  userData,
  arrPopularGeners,
}) => {
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  return (
    <View
      style={{
        marginTop: 10,
        // paddingHorizontal: 25,
        paddingLeft: deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 20 : 0,
        width: "100%",
        gap: 25,
      }}
    >
      <FlatList
        endFillColor="#000"
        overScrollMode="never"
        horizontal={true}
        // scrollEnabled={false}
        showsHorizontalScrollIndicator={false}
        style={{ paddingBottom: 15 }}
        data={arrPopularGeners}
        renderItem={({ item }) => (
          <TouchableOpacity
            style={{
              borderRadius: 10,
            }}
            onPress={() => {
              if (userData.username === item.userID) {
                navigateToScreen(navigation, AppScreens.Profile);
              } else {
                navigateToScreen(navigation, AppScreens.UserProfile, {
                    username: item.userID,
                  });
              }
            }}
          >
            <Avatar src={item.profilePicture} variant="player" />
            <View
              style={{
                alignItems: "center",
              }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_14,
                  { color: AppColors.white },
                ]}
              >
                {item.userID}
              </Text>
            </View>
          </TouchableOpacity>
        )}
        ItemSeparatorComponent={() => {
          return <View style={{ width: 20 }} />;
        }}
      />
    </View>
  );
};

export default PlayersViewScroll;
